module.exports = __webpack_public_path__ + "fonts/loading-fonts1.9325002.eot";


//////////////////
// WEBPACK FOOTER
// ./assets/loading/loading-fonts1.eot
// module id = ./assets/loading/loading-fonts1.eot
// module chunks = 2 3 4 5 6 7 8